import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';
import {
  default as DateRangeFilter,
  BottomRightFixedCustomOverlay
} from 'components/Filters/DateRangeFilter';
import BookerFilter from 'components/Filters/BookerFilter';
import SelectFilter from 'components/Filters/SelectFilter';
import TreeSelect from 'components/Filters/TreeSelect';

import {
  getBookingSetStatusGroups,
  getBookingSetStatusesForStatusGroup
} from 'ducks/bookingSets';

import './styles.css';

const bookingSetStatusFilters = getBookingSetStatusGroups().map(value => ({
  label: value,
  data: getBookingSetStatusesForStatusGroup(value).map(status => ({
    label: status,
    key: status
  }))
}));

interface BookingSetFiltersProps {
  locationRef: string;
  bookingTypes: any;
  depositSummaryStatuses: Array<string>;
  setFilter: (field: string, value: any) => void;
  getFilters: any;
  clearFilters: any;
}

class BookingSetFilters extends React.Component<BookingSetFiltersProps> {
  bookerRef: any = React.createRef();

  state = {
    dateSectionOpened: false,
    selectedFilters: []
  };

  toggleDateSection = () => {
    this.setState({dateSectionOpened: !this.state.dateSectionOpened});
  };

  onFilterChange = newFilters => {
    this.setState({
      selectedFilters: newFilters
    });
  };

  clearFilters = () => {
    this.bookerRef.onChange(null);

    this.props.clearFilters();
  };

  render() {
    const {
      getFilters,
      locationRef,
      bookingTypes,
      depositSummaryStatuses,
      setFilter
    } = this.props;

    const filters: any = getFilters();

    const bookingTypesData = bookingTypes.map(bookingType => ({
      label: bookingType.name,
      value: bookingType.name
    }));

    const depositSummaryStatusesData = depositSummaryStatuses.map(
      depositStatus => ({
        label: depositStatus,
        value: depositStatus
      })
    );

    return (
      <div className="BookingSetFilters colab-row-space-between">
        <div className="colab-sidepadding-2">
          <BookerFilter
            locationRef={locationRef}
            classNameForTesting="booker"
            filterBy={setFilter}
            bookerRef={el => (this.bookerRef = el)}
          />
          <TreeSelect
            label="Status"
            classNameForTesting="status"
            data={bookingSetStatusFilters}
            value={filters.statuses}
            onFilterChange={statuses => setFilter('statuses', statuses)}
          />
          <SelectFilter
            label="Booking types"
            classNameForTesting="bookingTypes"
            data={bookingTypesData}
            value={filters.bookingTypes}
            onChange={bookingTypes => setFilter('bookingTypes', bookingTypes)}
          />
          <SelectFilter
            label="Deposit Status"
            classNameForTesting="depositStatus"
            data={depositSummaryStatusesData}
            value={filters.depositStatuses}
            onChange={depositStatuses =>
              setFilter('depositStatuses', depositStatuses)
            }
          />
          <DateRangeFilter
            label="Start date"
            fieldName="startDate"
            classNameForTesting="startDate"
            start={filters.startDateAfter}
            end={filters.startDateBefore}
            startFieldName="startDateAfter"
            endFieldName="startDateBefore"
            overlayComponent={BottomRightFixedCustomOverlay}
            onChange={(dateField, date) => setFilter(dateField, date)}
          />
          <DateRangeFilter
            label="End date"
            fieldName="endDate"
            classNameForTesting="endDate"
            start={filters.endDateAfter}
            end={filters.endDateBefore}
            startFieldName="endDateAfter"
            endFieldName="endDateBefore"
            overlayComponent={BottomRightFixedCustomOverlay}
            onChange={(dateField, date) => setFilter(dateField, date)}
          />
        </div>
        <div>
          <Button clear onClick={this.clearFilters}>
            Clear all filters
          </Button>
        </div>
      </div>
    );
  }
}

export default BookingSetFilters;
